import { makeStyles } from '@mui/styles';
const useStyles = makeStyles(() => ({
  disclaimerStyle: {
    fontSize: '0.875rem',
    color: '#6c757d',
    marginTop: '-12px',
    marginBottom: '-22px',
  },
}));

export default useStyles;
